/**
 * @generated SignedSource<<d9c1b496e13925f098b7aade6a71b6b8>>
 * @relayHash 8fcbb253b1dad6b6e61097d35a44d367
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 374c523a951f59a6c595a275cc070c255ab9d720fa5e91fd08ac043fc7d5453d

import type { ConcreteRequest, Query } from 'relay-runtime';
export type JiraBoardViewInput = {
  jiraBoardViewQueryInput: JiraBoardViewQueryInput;
  settings?: JiraBoardViewSettings | null | undefined;
};
export type JiraBoardViewQueryInput = {
  projectKeyAndItemIdQuery?: JiraBoardViewProjectKeyAndItemIdQuery | null | undefined;
  viewId?: string | null | undefined;
};
export type JiraBoardViewProjectKeyAndItemIdQuery = {
  cloudId: string;
  itemId: string;
  projectKey: string;
};
export type JiraBoardViewSettings = {
  filterJql?: string | null | undefined;
  groupBy?: string | null | undefined;
};
export type CardActionsMenuContentQuery$variables = {
  cloudId: string;
  projectAri: string;
  viewInput: JiraBoardViewInput;
};
export type CardActionsMenuContentQuery$data = {
  readonly jira: {
    readonly jiraProject: {
      readonly canCreateIssues: {
        readonly canPerform: boolean;
      };
      readonly canDeleteIssues: {
        readonly canPerform: boolean;
      };
      readonly canEditIssues: {
        readonly canPerform: boolean;
      };
      readonly canLinkIssues: {
        readonly canPerform: boolean;
      };
      readonly canScheduleIssues: {
        readonly canPerform: boolean;
      };
    };
  };
  readonly jira_boardView: {
    readonly id: string;
  };
  readonly jira_categoryField: {
    readonly fieldId: string;
  } | null | undefined;
};
export type CardActionsMenuContentQuery = {
  response: CardActionsMenuContentQuery$data;
  variables: CardActionsMenuContentQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectAri"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "viewInput"
},
v3 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v4 = {
  "kind": "ScalarField",
  "name": "fieldId"
},
v5 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "viewInput"
  }
],
v6 = {
  "kind": "ScalarField",
  "name": "id"
},
v7 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "projectAri"
  }
],
v8 = [
  {
    "kind": "Literal",
    "name": "type",
    "value": "CREATE_ISSUES"
  }
],
v9 = {
  "kind": "ScalarField",
  "name": "canPerform"
},
v10 = [
  {
    "kind": "Literal",
    "name": "type",
    "value": "DELETE_ISSUES"
  }
],
v11 = [
  {
    "kind": "Literal",
    "name": "type",
    "value": "EDIT_ISSUES"
  }
],
v12 = [
  {
    "kind": "Literal",
    "name": "type",
    "value": "LINK_ISSUES"
  }
],
v13 = [
  {
    "kind": "Literal",
    "name": "type",
    "value": "SCHEDULE_ISSUES"
  }
],
v14 = [
  (v9/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "CardActionsMenuContentQuery",
    "selections": [
      {
        "args": (v3/*: any*/),
        "concreteType": "JiraJqlField",
        "kind": "LinkedField",
        "name": "jira_categoryField",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": (v4/*: any*/),
            "action": "THROW",
            "path": "jira_categoryField.fieldId"
          }
        ]
      },
      {
        "kind": "RequiredField",
        "field": {
          "args": (v5/*: any*/),
          "concreteType": "JiraBoardView",
          "kind": "LinkedField",
          "name": "jira_boardView",
          "plural": false,
          "selections": [
            {
              "kind": "RequiredField",
              "field": (v6/*: any*/),
              "action": "THROW",
              "path": "jira_boardView.id"
            }
          ]
        },
        "action": "THROW",
        "path": "jira_boardView"
      },
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "kind": "RequiredField",
              "field": {
                "args": (v7/*: any*/),
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "jiraProject",
                "plural": false,
                "selections": [
                  {
                    "kind": "RequiredField",
                    "field": {
                      "alias": "canCreateIssues",
                      "args": (v8/*: any*/),
                      "concreteType": "JiraProjectAction",
                      "kind": "LinkedField",
                      "name": "action",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "RequiredField",
                          "field": (v9/*: any*/),
                          "action": "THROW",
                          "path": "jira.jiraProject.canCreateIssues.canPerform"
                        }
                      ],
                      "storageKey": "action(type:\"CREATE_ISSUES\")"
                    },
                    "action": "THROW",
                    "path": "jira.jiraProject.canCreateIssues"
                  },
                  {
                    "kind": "RequiredField",
                    "field": {
                      "alias": "canDeleteIssues",
                      "args": (v10/*: any*/),
                      "concreteType": "JiraProjectAction",
                      "kind": "LinkedField",
                      "name": "action",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "RequiredField",
                          "field": (v9/*: any*/),
                          "action": "THROW",
                          "path": "jira.jiraProject.canDeleteIssues.canPerform"
                        }
                      ],
                      "storageKey": "action(type:\"DELETE_ISSUES\")"
                    },
                    "action": "THROW",
                    "path": "jira.jiraProject.canDeleteIssues"
                  },
                  {
                    "kind": "RequiredField",
                    "field": {
                      "alias": "canEditIssues",
                      "args": (v11/*: any*/),
                      "concreteType": "JiraProjectAction",
                      "kind": "LinkedField",
                      "name": "action",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "RequiredField",
                          "field": (v9/*: any*/),
                          "action": "THROW",
                          "path": "jira.jiraProject.canEditIssues.canPerform"
                        }
                      ],
                      "storageKey": "action(type:\"EDIT_ISSUES\")"
                    },
                    "action": "THROW",
                    "path": "jira.jiraProject.canEditIssues"
                  },
                  {
                    "kind": "RequiredField",
                    "field": {
                      "alias": "canLinkIssues",
                      "args": (v12/*: any*/),
                      "concreteType": "JiraProjectAction",
                      "kind": "LinkedField",
                      "name": "action",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "RequiredField",
                          "field": (v9/*: any*/),
                          "action": "THROW",
                          "path": "jira.jiraProject.canLinkIssues.canPerform"
                        }
                      ],
                      "storageKey": "action(type:\"LINK_ISSUES\")"
                    },
                    "action": "THROW",
                    "path": "jira.jiraProject.canLinkIssues"
                  },
                  {
                    "kind": "RequiredField",
                    "field": {
                      "alias": "canScheduleIssues",
                      "args": (v13/*: any*/),
                      "concreteType": "JiraProjectAction",
                      "kind": "LinkedField",
                      "name": "action",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "RequiredField",
                          "field": (v9/*: any*/),
                          "action": "THROW",
                          "path": "jira.jiraProject.canScheduleIssues.canPerform"
                        }
                      ],
                      "storageKey": "action(type:\"SCHEDULE_ISSUES\")"
                    },
                    "action": "THROW",
                    "path": "jira.jiraProject.canScheduleIssues"
                  }
                ]
              },
              "action": "THROW",
              "path": "jira.jiraProject"
            }
          ]
        },
        "action": "THROW",
        "path": "jira"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "CardActionsMenuContentQuery",
    "selections": [
      {
        "args": (v3/*: any*/),
        "concreteType": "JiraJqlField",
        "kind": "LinkedField",
        "name": "jira_categoryField",
        "plural": false,
        "selections": [
          (v4/*: any*/)
        ]
      },
      {
        "args": (v5/*: any*/),
        "concreteType": "JiraBoardView",
        "kind": "LinkedField",
        "name": "jira_boardView",
        "plural": false,
        "selections": [
          (v6/*: any*/)
        ]
      },
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v7/*: any*/),
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "jiraProject",
            "plural": false,
            "selections": [
              {
                "alias": "canCreateIssues",
                "args": (v8/*: any*/),
                "concreteType": "JiraProjectAction",
                "kind": "LinkedField",
                "name": "action",
                "plural": false,
                "selections": (v14/*: any*/),
                "storageKey": "action(type:\"CREATE_ISSUES\")"
              },
              {
                "alias": "canDeleteIssues",
                "args": (v10/*: any*/),
                "concreteType": "JiraProjectAction",
                "kind": "LinkedField",
                "name": "action",
                "plural": false,
                "selections": (v14/*: any*/),
                "storageKey": "action(type:\"DELETE_ISSUES\")"
              },
              {
                "alias": "canEditIssues",
                "args": (v11/*: any*/),
                "concreteType": "JiraProjectAction",
                "kind": "LinkedField",
                "name": "action",
                "plural": false,
                "selections": (v14/*: any*/),
                "storageKey": "action(type:\"EDIT_ISSUES\")"
              },
              {
                "alias": "canLinkIssues",
                "args": (v12/*: any*/),
                "concreteType": "JiraProjectAction",
                "kind": "LinkedField",
                "name": "action",
                "plural": false,
                "selections": (v14/*: any*/),
                "storageKey": "action(type:\"LINK_ISSUES\")"
              },
              {
                "alias": "canScheduleIssues",
                "args": (v13/*: any*/),
                "concreteType": "JiraProjectAction",
                "kind": "LinkedField",
                "name": "action",
                "plural": false,
                "selections": (v14/*: any*/),
                "storageKey": "action(type:\"SCHEDULE_ISSUES\")"
              },
              (v6/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "374c523a951f59a6c595a275cc070c255ab9d720fa5e91fd08ac043fc7d5453d",
    "metadata": {},
    "name": "CardActionsMenuContentQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "86dc9d98e41a92f0c071c5e4ccd7be2c";

export default node;
